// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";


// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import { useContext, useEffect, useState } from "react";

import moment from "moment";
import { getPricingTemplates, getPricingGroups } from "network/service";
import { useNavigate } from "react-router-dom";
import { Autocomplete } from "@mui/material";
import MDInput from "components/MDInput";
import { useLoading } from "context/loading.context";
import { getCountries, fetchModes } from "network/service";
import { getPriceList, calculatePricing } from "network/service";
import Divider from "@mui/material/Divider";
import { AuthContext } from "context/auth.context";
import { getBranches } from "network/service";


export default function PricingCalculator() {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [templates, setTemplates] = useState([]);
    const [groups, setGroups] = useState([]);
    const [countries, setCountries] = useState([]);
    const [modes, setModes] = useState([]);
    const [selTempl, setSelTempl] = useState([]);
    const [selgrp, setSelGrp] = useState([]);
    const [selCnt, setSelCnt] = useState([]);
    const [selMode, setSelMode] = useState([]);
    const [templatepopup, setTemplatePopp] = useState({ visible: false, details: null });
    const [groupPopup, setGroupPopup] = useState({ visible: false, details: null });
    const [pricelistPopup, setPriceListPopup] = useState({ visible: false, details: null });
    const { showLoader, hideLoader } = useLoading();
    const [weight, setWeight] = useState("");
    const [vals, setVals] = useState([]);
    const { userDoc } = useContext(AuthContext);
    const [branches, setBranches] = useState([]);
    const [selBranch, setSelBranch] = useState(null);

    const fetchPricingTemplates = async () => {
        getPricingTemplates().then((resp) => {
            setTemplates(resp.data);
        }).catch((err) => {
            console.log(err);
        })
    }

    const fetchPricingGroups = async () => {
        getPricingGroups().then((resp) => {
            setGroups(resp.data);
        }).catch((err) => {
            console.log(err);
        })
    }

    const fetchCountries = async () => {
        getCountries().then((resp) => {
            setCountries(resp.data);
        }).catch((err) => {
            console.log(err);
        });
    }

    const fetchPriceModes = async () => {
        fetchModes().then((resp) => {
            setModes(resp.data);
        }).catch((err) => {
            console.log(err);
        });
    }

    const calculatePrice = async () => {
        let req_body = {
            pricing_template: selTempl._id,
            pricing_group: null,
            country: selCnt._id,
            weight: parseFloat(weight)
        };
        if (userDoc.role?.name === "Branch Admin") {
            req_body.pricing_group = selBranch?.pricing_group?._id ?? null;
        }
        else {
            req_body.pricing_group = selgrp._id;
        }
        calculatePricing(req_body).then((resp) => {
            console.log(resp.data);
            setVals(resp.data);
        }).catch((err) => {
            console.log(err);
        })
    }



    useEffect(() => {
        fetchPricingTemplates();
    }, [setTemplates]);

    useEffect(() => {
        fetchCountries();
    }, [setCountries]);

    useEffect(() => {
        fetchPricingGroups();
    }, [setGroups]);

    useEffect(() => {
        fetchPriceModes();
    }, [setModes]);

    useEffect(() => {
        if (userDoc.role?.name === "Branch Admin") {
            getBranches().then((resp) => {
                setBranches(resp.data);
            }).catch((err) => {
                console.log(err);
            });
        }
    }, [userDoc]);



    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}><Grid container spacing={6}>
                <Grid item xs={12}>
                    <Card>
                        <MDBox
                            mx={2}
                            mt={-3}
                            py={3}
                            px={2}
                            variant="gradient"
                            bgColor="info"
                            borderRadius="lg"
                            coloredShadow="info"
                        >
                            <MDTypography variant="h6" color="white">
                                Templates
                            </MDTypography>
                        </MDBox>
                        <Grid
                            container xs={12}
                            direction='row'
                            width={"100%"}
                            className="form-wrapper"
                            style={{ display: 'flex', alignItems: 'center', justifyContent: "space-around", margin: 10 }}
                        >
                            {
                                userDoc.role?.name === "Super Admin" &&
                                <Grid item xs={5} xl={2} className="form-content">
                                    <Autocomplete
                                        disableClearable
                                        style={{ flex: "7", margin: 0 }}
                                        label="Template"
                                        options={templates}
                                        getOptionLabel={(option) => option.template_name || ''}
                                        renderInput={(params) => <MDInput {...params} label="Template" />}
                                        onChange={(event, newValue) => {
                                            setSelTempl(newValue);
                                        }}
                                        value={selTempl}
                                    />
                                </Grid>
                            }
                            {
                                userDoc.role?.name === "Super Admin" &&
                                <Grid item xs={5} xl={2} className="form-content">
                                    <Grid container flexDirection={"row"} alignItems="center" justifyContent="space-between">
                                        <Autocomplete
                                            disableClearable
                                            style={{ flex: "7", margin: 0 }}
                                            label="Group"
                                            options={groups}
                                            getOptionLabel={(option) => option.name || ''}
                                            renderInput={(params) => <MDInput {...params} label="Group" />}
                                            onChange={(event, newValue) => {
                                                setSelGrp(newValue);
                                            }}
                                            value={selgrp}
                                        />
                                    </Grid>
                                </Grid>
                            }

                            {
                                userDoc.role?.name === "Branch Admin" &&
                                <Grid item xs={12} xl={4} className="form-content">
                                    <Grid container flexDirection={"row"} alignItems="center" justifyContent="space-between">
                                        <Autocomplete
                                            disableClearable
                                            style={{ flex: "7", margin: 0 }}
                                            label="Branch"
                                            options={branches}
                                            getOptionLabel={(option) => option.name || ''}
                                            renderInput={(params) => <MDInput {...params} label="Branch" />}
                                            onChange={(event, newValue) => {
                                                setSelBranch(newValue);
                                            }}
                                            value={selBranch}
                                        />
                                    </Grid>
                                </Grid>
                            }


                            <Grid item xs={5} xl={2} className="form-content">
                                <Autocomplete
                                    style={{ flex: "7", margin: 0 }}
                                    label="Country"
                                    options={countries}
                                    getOptionLabel={(option) => option.name || ''}
                                    renderInput={(params) => <MDInput {...params} label="Country" />}
                                    onChange={(event, newValue) => {
                                        setSelCnt(newValue);
                                    }}
                                    value={selCnt}
                                />
                            </Grid>
                            <Grid item xs={5} xl={2} className="form-content">
                                <MDInput
                                    fullWidth
                                    label="Weight"
                                    value={weight}
                                    onChange={(e) => {
                                        setWeight(e.target.value);
                                    }}
                                />
                            </Grid>
                            <MDButton variant="gradient" color="info" style={{ margin: 5 }}
                                onClick={async () => {
                                    calculatePrice();
                                }}>
                                <Icon sx={{ fontWeight: "bold" }}>refresh</Icon>
                                &nbsp;Calculate
                            </MDButton>
                        </Grid>
                        <Divider sx={{ margin: 1 }} light={false} />
                        <DataTable
                            table={{
                                columns: [
                                    { Header: "Mode", accessor: "mode", align: "center" },
                                    { Header: "Price", accessor: "rate", align: "center" }
                                ],
                                rows: vals.map((item) => {
                                    return {
                                        mode: item.mode,
                                        rate: item.rate
                                    }
                                })
                            }}
                            canSearch />
                    </Card>
                </Grid>
            </Grid>
            </MDBox>
        </DashboardLayout>
    );
}